/* @flow */
const TYPES = ['products', 'assets', 'history'];

export const TAB_CONFIG = [
  {
    label: 'exchange-lending-products',
    key: 'products',
  },
  {
    label: 'exchange-lending-assets',
    key: 'assets',
  },
  {
    label: 'exchange-lending-history',
    key: 'history',
  },
];

export const HISTORY_TABS = [
  {
    label: 'exchange-lending-Subscription',
    key: 'Subscription',
  },
  {
    label: 'exchange-lending-Redemption',
    key: 'Redemption',
  },
];

export const STATUS_MAP = {
  PREHEATING: {
    label: 'exchange-lending-Preparation',
    bgColor: 'rgba(242, 48, 81, 0.15)',
    fgColor: '#F23051',
    disable: true,
    showTimer: true,
    btnText: 'exchange-lending-Subscribe',
  },
  PURCHASING: {
    label: 'exchange-lending-Subscription',
    bgColor: 'rgba(240, 185, 11, 0.15)',
    fgColor: '#F0B90B',
    disable: false,
    showTimer: true,
    btnText: 'exchange-lending-Subscribe',
  },
  PURCHASED: {
    label: 'exchange-lending-Subscriptionends',
    bgColor: 'rgba(234, 236, 239, 0.4)',
    fgColor: '#48515D',
    disable: true,
    showTimer: false,
    btnText: 'exchange-lending-End',
  },
  DEDUCTED: {
    label: 'exchange-lending-Subscriptionends',
    bgColor: 'rgba(0, 192, 135, 0.15)',
    fgColor: '#00C087',
    disable: true,
    showTimer: false,
    btnText: 'exchange-lending-End',
  },
  RUNNING: {
    label: 'exchange-lending-AccuringInterest',
    bgColor: 'rgba(0, 192, 135, 0.15)',
    fgColor: '#00C087',
    disable: true,
    showTimer: false,
    btnText: 'exchange-lending-End',
  },
  PRE_REDEMPTION: {
    label: 'exchange-lending-Redemption',
    bgColor: 'rgba(240, 185, 11, 0.15)',
    fgColor: '#F0B90B',
    disable: true,
    showTimer: false,
    btnText: 'exchange-lending-End',
  },
  REDEEMED: {
    label: 'exchange-lending-End',
    bgColor: 'rgba(234, 236, 239, 0.4)',
    fgColor: '#48515D',
    disable: true,
    showTimer: false,
    btnText: 'exchange-lending-End',
  },
};

export const STATUS = {
  PREHEATING: 'PREHEATING',
  PURCHASING: 'PURCHASING',
  PURCHASED: 'PURCHASED',
  REDEEMED: 'REDEEMED',
};

export const getErrorCode = (code: string) => ['077011', '077005', '077013'].includes(code) ? `exchange-lending-${code}` : 'exchange-lending-000000';

export const getDateKey = (status: string) => {
  let rs = {
    key: 'startTime',
    label: 'exchange-lending-vdate',
  };
  if (status === 'PREHEATING') {
    rs = {
      key: 'issueStartTime',
      label: 'exchange-common-sstarttime',
    };
  } else if (status === 'PURCHASING') {
    rs = {
      key: 'issueEndTime',
      label: 'exchange-lending-endime',
    };
  }
  return rs;
};
export const formatType = (type: string = 'products') => {
  type = type.toLowerCase();
  return TYPES.includes(type) ? type : 'products';
};

export default {};
